module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("标准")]), _vm._v(" "), _c('btn', {
    attrs: {
      "btn-w": "100%",
      "value": "btn 100%",
      "belongs": "btn",
      "callback": _vm.callback()
    }
  }), _vm._v(" "), _c('btn', {
    attrs: {
      "btn-w": "30%",
      "value": "btn-primary 30%",
      "belongs": "btn-primary",
      "callback": _vm.callback
    }
  }), _vm._v(" "), _c('btn', {
    attrs: {
      "btn-w": "30%",
      "loading": "true",
      "value": "btn-primary",
      "belongs": "btn-primary radius",
      "callback": _vm.callback
    }
  }), _vm._v(" "), _c('btn', {
    attrs: {
      "btn-w": "30%",
      "value": "btn-primary 30%",
      "belongs": "btn-primary",
      "callback": _vm.callback
    }
  }), _vm._v(" "), _c('btn', {
    attrs: {
      "btn-w": "30%",
      "value": "btn-warn",
      "belongs": "btn-warn",
      "callback": _vm.callback
    }
  }), _vm._v(" "), _c('btn', {
    attrs: {
      "btn-w": "30%",
      "loading": "true",
      "value": "btn-warn",
      "belongs": "btn-warn radius",
      "callback": _vm.callback
    }
  }), _vm._v(" "), _c('btn', {
    attrs: {
      "btn-w": "30%",
      "value": "btn-warn",
      "belongs": "btn-warn radius20",
      "callback": _vm.callback
    }
  }), _vm._v(" "), _c('btn', {
    attrs: {
      "btn-w": "30%",
      "value": "btn-delete",
      "belongs": "btn-delete",
      "callback": _vm.callback
    }
  }), _vm._v(" "), _c('btn', {
    attrs: {
      "btn-w": "30%",
      "loading": "true",
      "value": "btn-delete",
      "belongs": "btn-delete radius",
      "callback": _vm.callback
    }
  }), _vm._v(" "), _c('btn', {
    attrs: {
      "btn-w": "30%",
      "value": "btn-delete",
      "belongs": "btn-delete radius20",
      "callback": _vm.callback
    }
  }), _vm._v(" "), _c('btn', {
    attrs: {
      "btn-w": "30%",
      "value": "btn-ghost 30%",
      "belongs": "btn-ghost",
      "callback": _vm.callback
    }
  }), _vm._v(" "), _c('btn', {
    attrs: {
      "btn-w": "30%",
      "value": "btn-ghost 30%",
      "belongs": "btn-ghost radius",
      "callback": _vm.callback
    }
  }), _vm._v(" "), _c('btn', {
    attrs: {
      "btn-w": "30%",
      "value": "btn-ghost 30%",
      "belongs": "btn-ghost radius20",
      "callback": _vm.callback
    }
  }), _vm._v(" "), _c('btn', {
    attrs: {
      "btn-w": "20%",
      "value": "btn-more 200px",
      "disable": false,
      "belongs": "btn-more",
      "callback": _vm.callback
    }
  }), _vm._v(" "), _c('btn', {
    attrs: {
      "btn-w": "20%",
      "value": "btn-disable",
      "loading": "true",
      "active": _vm.active,
      "disable": true,
      "belongs": "btn-disable",
      "callback": _vm.callback
    }
  }), _vm._v(" "), _c('btn', {
    attrs: {
      "btn-w": "20%",
      "value": "btn-loading",
      "loading": "true",
      "belongs": "btn-loading",
      "callback": _vm.callback
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-68b91650"}!./~/.11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/pages/Buttons.vue
// module id = 70
// module chunks = 13